import React, { FC } from 'react';
import CmsImage from 'components/CmsImage';
import { H3 } from '@thisisdevelopment/akzonobel-core';
import Link from 'next/link';
import { CmsCallToActionStyled } from './styled';

export type CmsCallToActionType = {
  title: string;
  button_label: string;
  button_link: string;
  file_id: number;
};

type PropType = {
  callToAction: CmsCallToActionType;
};

const CmsCallToAction: FC<PropType> = ({ callToAction }: PropType) => {
  return (
    <CmsCallToActionStyled>
      <CmsImage id={callToAction.file_id} alt={'Banner Image'} />
      <H3>{callToAction.title}</H3>
      <Link href={callToAction.button_link}>{callToAction.button_label}</Link>
    </CmsCallToActionStyled>
  );
};

export default CmsCallToAction;
